import * as THREE from 'three';

const TRAUMA_MAX = 1;
const TRAUMA_DECAY = 1.4; // trauma units per second
const MAX_OFFSET = 0.5; // world units at full shake
const MAX_ROLL = 0.09; // radians at full shake

// Deterministic value noise in [-1, 1]; per-axis seed keeps axes independent.
function pseudoNoise(t: number, seed: number): number {
  const x = Math.sin(t * 12.9898 + seed * 78.233) * 43758.5453;
  return (x - Math.floor(x)) * 2 - 1;
}

/** Trauma-based screenshake: shake = trauma^2, driven by accumulated time. */
export class ShakeRig {
  private trauma = 0;
  private time = 0;
  private intensity = 1;

  addTrauma(amount: number): void {
    this.trauma = Math.min(TRAUMA_MAX, this.trauma + amount);
  }

  /** Accessibility scale (0 disables shake entirely). */
  setIntensity(value: number): void {
    this.intensity = value;
  }

  reset(): void {
    this.trauma = 0;
  }

  // Call every frame AFTER CameraRig has written the base transform.
  update(delta: number, camera: THREE.PerspectiveCamera): void {
    this.time += delta;
    this.trauma = Math.max(0, this.trauma - TRAUMA_DECAY * delta);
    if (this.trauma <= 0 || this.intensity <= 0) return;
    const shake = this.trauma * this.trauma * this.intensity;
    const freq = this.time * 32;
    camera.position.x += MAX_OFFSET * shake * pseudoNoise(freq, 1);
    camera.position.y += MAX_OFFSET * shake * pseudoNoise(freq, 2);
    camera.rotation.z += MAX_ROLL * shake * pseudoNoise(freq, 3);
  }
}
